import { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import Lottie from "react-lottie";
import * as successVerification from "../../../../lottie/lottie_success.json";
import * as failedVerification from "../../../../lottie/lottie_failed.json";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [message, setMessage] = useState('Verifying...');
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/verify-email-token/`, { token });
        setSuccess(true);
        setMessage(response.data.success || 'Email verified successfully.');

        // ✅ Redirect to login after 3 seconds
        // setTimeout(() => {
        //   navigate('/login');
        // }, 3000);

      } catch (error) {
        setSuccess(false);
        const msg = error.response?.data?.message || 'Verification failed.';
        setMessage(msg);
      }
    };

    if (token) {
      verify();
    } else {
      setSuccess(false);
      setMessage('Token not found.');
    }
  }, [token, navigate]);


    const defaultOptionsLottieSuccess = {
      loop: true,
      autoplay: true,
      animationData: successVerification,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

     const defaultOptionsLottieFailed = {
      loop: true,
      autoplay: true,
      animationData: failedVerification,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

  return (
    <div className="d-flex col-12 align-items-center authentication-bg p-4 p-sm-5 vh-100">
      <div className="w-px-400 mx-auto">
        <div className="app-brand mb-5">

          <span className="app-brand-text demo text-body fw-bold text-uppercase">ENOTARY SAYS ...</span>
        </div>
      
        <div className="card p-4 text-center">

          



          <span className={`mb-3 ${success ? 'text-success' : 'text-danger fs-1'}`}>
            {success === null ? 'Verifying...' : success ? 
            
             <>
               <h4 className="mb-2">Verifying your account.🔒</h4>
                <Lottie isClickToPauseDisabled={true} options={defaultOptionsLottieSuccess} height={250} width={250} />
                <span className=" fw-bold fs-6 mt-n4 mb-2" style={{ letterSpacing: "1px" }} >
                  ACCOUNT VERIFIED!
                </span>
                <br/>

         
                 <Link to="/iusevolutione/login"  className="btn btn-primary text-nowrap mt-4" >
                 Go to login
                </Link>

              </>


            : 

            <>
              <h4 className="mb-2">Verifying your account.🔒</h4>
                <Lottie isClickToPauseDisabled={true} options={defaultOptionsLottieFailed} height={250} width={250} />
                <span className=" fw-bold fs-6 mt-n4 mb-2 text-uppercase" style={{ letterSpacing: "1px" }} >
                  ACCOUNT VERIFICATION FAILED!<br/>
                  {message}
                </span>
                <br/>


                <Link to="/iusevolutione/login"  className="btn btn-primary text-nowrap mt-4" >
                 Go to login
                </Link>


              </>       
            }
          </span>
        </div>
      </div>
    </div>
    );
};

export default VerifyEmailPage;
